import React from 'react';

import { useCreateSharedAccountsPA } from 'scenes/CustomAudiences/PartnerAudiences/data/mutations';

import ShareAccounts from './ShareAccountsForm';

export { PARTNER_AUDIENCE } from './constants';

const ShareAccountsForm = ({ initialValues, onSubmit, ...props }) => {
  const [createSharedAccountsPartner, { isLoading }] =
    useCreateSharedAccountsPA();

  const handleSubmit = async (values = {}) => {
    await createSharedAccountsPartner(values);
    props.onClose();
  };

  return (
    <ShareAccounts
      loading={isLoading}
      initialValues={initialValues}
      onSubmit={handleSubmit}
      {...props}
    />
  );
};

export default ShareAccountsForm;
